module.exports = __webpack_public_path__ + "img/engagement.0aa1900b.png";